//NPM
import React, { useEffect, useState } from "react"
import { map } from "lodash"
import { useTranslation } from "react-i18next"

import useSession from "Hooks/session.hook"


// COMPONENTS
import { Col, Row, Switch } from 'antd';
import {
    ActionMenu,
    DataTable,
    TimePicker,
    SelectInput,
} from "@life-line-lab/components-react"
import { BasicModal } from "@life-line-lab/components-react";
import { CaretDownOutlined, CaretUpOutlined, MoreOutlined } from '@ant-design/icons';
import { AddRoutingTimeForm } from 'Components/delivery-management/delivery-forms/'

import './delivery-lists.scss';

interface RoutingProps {
    offset?: number,
    list?: any,
    routingData?: any,
    onCreateTime?: any,
    // onFilter?: (filterInput) => void
    onUpdateTime?: any,
}

const RoutingList: React.FC<RoutingProps> = ({
    offset,
    list,
    routingData,
    onCreateTime,
    onUpdateTime,
}) => {
    const { org } = useSession()
    const initialModal: any = {
        open: false,
    };
    const initialInput: any = {
        orgID: '',
        feature: '',
        active: true,
        runTime: [{ startDate: '', startTime: '', Interval: '', active: true }]
    }

    const [input, setInput] = useState<any>(initialInput)
    const [modal, setModal] = useState<any>(initialModal);
    const [callModal, setCallModal] = useState<any>(<></>);
    const { t } = useTranslation()

    const handleResetModalState = () => {
        setModal(initialModal);
    };

    const timeTranslator = (time) => {
        if (time == 12) {
            return (time + ' pm')
        } else if (time == 0) {
            return (12 + ' am')
        } else if (time > 12) {
            return (time - 12 + ' pm')
        } else {
            return (time + ' am')
        }
    }

    const columns = [
        {
            title: t("label.feature").toLocaleUpperCase(),
            dataIndex: "feature",
        },
        {
            title: t("label.description").toLocaleUpperCase(),
            dataIndex: "description",
        },
        {
            title: '',
            dataIndex: '',
            key: "switch",
            width: 80,
            render: (_: any, record: any) => {
                return <Switch checked={record.active} onChange={(value)=>onUpdateTime(value, record, 'feature-active')} />
            }
        },
        {
            title: "",
            dataIndex: "action",
            width: 40,
            render: (_: any, record: any) =>
                <ActionMenu
                    label={<MoreOutlined />}
                    actions={[{
                        label: t("action.add"),
                        onClick: () => { handleAddTimeModal(record) }
                    }, {
                        label: t("action.test"),
                        onClick: () => { onCreateTime() }
                    }]}
                />
        },
    ]

    const handleAddTimeModal = (feature) => {
        setCallModal(
            <AddRoutingTimeForm id={false}
                onSubmit={((feature, value) => handleCreateTime(feature, value))}
            />
        );
        setModal({ open: true });
    }

    const handleCreateTime = (feature, value) => {
        let inputData = { orgID: org._id, feature: feature.feature, active: true, runTime: value.runTime}
        // setInput({ orgID: org._id, feature: feature.feature, active: true, runTime: value.runTime })
        onCreateTime(inputData)
        console.log('createTime', inputData)
    }




    const DropdownTimeComponent = (data) => {
        const time = timeTranslator(data.time.startTime)
        return (
            <div className="dropdownTimeComponents">
                <Row justify="space-between">
                    <Col span={12}>
                        <span><p>{time}</p></span>
                    </Col>
                    <Col span={4}>
                        <Switch checked={data.time.active} onChange={(value)=>onUpdateTime(value, data.record, 'active')} />
                    </Col>
                    <Col span={8} style={{alignSelf:'flex-end'}}>
                        <ActionMenu
                            label={<MoreOutlined />}
                            actions={[{
                                label: t("action.edit"),
                                onClick: () => { handleAddTimeModal(data.record.feature) }
                            }]}
                        />
                    </Col>
                </Row>
            </div>
        )
    }

    return (
        <div className="delivery-list">
            <DataTable
                rowKey={(record: any) => { return record._id }}
                columns={columns}
                dataSource={routingData || []}
                scroll={{ x: true }}
                expandable={{
                    rowExpandable: (record) => record.runTime.length >= 1,
                    expandIcon: ({ expanded, onExpand, record }) =>
                        record.runTime.length < 1 ? null : expanded ? (
                            <>
                                <CaretUpOutlined onClick={(e) => onExpand(record, e)} />
                            </>
                        ) : (
                            <>
                                <CaretDownOutlined onClick={(e) => onExpand(record, e)} />
                            </>
                        ),
                    expandedRowRender: (record: any) => {
                        return map(record.runTime, (time, i) => {
                            return (
                                <DropdownTimeComponent time={time} record={record} />
                            )
                        })
                    },
                }}
            />
            <BasicModal
                className="modal"
                isOpen={modal.open}
                isClosable={true}
                isMaskClosable={false}
                onClose={() => {
                    handleResetModalState();
                }}
            >
                {callModal}
            </BasicModal >
        </div >
    );
};

export default RoutingList;